const grid = {
  large: '32px',
  medium: '24px',
  regular: '16px',
  small: '8px',
  radius: '4px',
  maxWidth: '864px'
};

export default grid;
